<template>
  <div class="twitter-analytics-public">
    <div class="loading-bar" v-if="loading"></div>
    <div class="loading-bar-hide" v-else></div>
    <div v-if="!campaign || !campaign.id"></div>
    <div class="twitter-analytics-public-container" v-else>
      <TwitterAnalyticsPublicHeader class="mb-x2"></TwitterAnalyticsPublicHeader>
      <TwitterAnalyticsPublicFilter class="mb-x2"></TwitterAnalyticsPublicFilter>
      <TwitterAnalyticsPublicSummary class="mb-x2"></TwitterAnalyticsPublicSummary>
      <TwitterAnalyticsPublicChart></TwitterAnalyticsPublicChart>
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import TwitterAnalyticsPublicChart from '@/client/features/twitter_analytics_public/twitter_analytics_public_chart'
import TwitterAnalyticsPublicFilter from '@/client/features/twitter_analytics_public/twitter_analytics_public_filter'
import TwitterAnalyticsPublicHeader from '@/client/features/twitter_analytics_public/twitter_analytics_public_header'
import TwitterAnalyticsPublicSummary from '@/client/features/twitter_analytics_public/twitter_analytics_public_summary'
import { useTwitterAnalyticsPublicStore } from '@/client/store/useTwitterAnalyticsPublicStore'
import { getAnalyticsDefaultPeriod } from '@/common/utils/analytics_period'

export default defineComponent({
  components: {
    TwitterAnalyticsPublicChart,
    TwitterAnalyticsPublicFilter,
    TwitterAnalyticsPublicHeader,
    TwitterAnalyticsPublicSummary
  },
  computed: {
    ...mapState(useTwitterAnalyticsPublicStore, {
      params: state => state.params,
      campaign: state => state.campaign,
      loading: state => state.loading
    })
  },
  async created() {
    const hash = this.$route.query.hash as string

    if (!hash) {
      return
    }

    const params = { hash }

    this.setParams(params)

    await this.fetchCampaign()
    await this.fetchPrizes()

    if (!this.campaign || !this.campaign.id) {
      return
    }

    const [startDatetime, endDatetime] = getAnalyticsDefaultPeriod(
      this.campaign.startDatetime,
      this.campaign.endDatetime
    )

    this.setParams({
      startDatetime: moment(startDatetime).format('YYYY-MM-DD'),
      endDatetime: moment(endDatetime).format('YYYY-MM-DD')
    })

    await this.fetchCampaignAnalytics()
    await this.fetchFollowerAnalytics()
  },
  methods: {
    ...mapActions(useTwitterAnalyticsPublicStore, [
      'fetchCampaignAnalytics',
      'fetchFollowerAnalytics',
      'fetchCampaign',
      'fetchPrizes',
      'setParams'
    ])
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.twitter-analytics-public-container {
  max-width: $max-content-width;
  padding: $spacing-unit * 2;
  margin: 0 auto;
  background-color: #fff;
}
</style>
